(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ModuleTypeEnum = {
  DataModule: 'DataModule',
  // contains components to view/edit data
  MenuModule: 'MenuModule',
  // contains options to be shown in global menu
  TimelineModule: 'TimelineModule',
  // contains data providers to be shown in timeline
  WidgetModule: 'WidgetModule' // contains options to show a widget in dashboard

};
var _default = ModuleTypeEnum;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ModuleTypeEnum, "ModuleTypeEnum", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/enums/ModuleType.enum.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/enums/ModuleType.enum.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();